exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#login-message[data-v-7c875044] {color: red; background: #ffe6e6; margin: 0 16px 10px; line-height: 24px; border-radius: 2px;\n}\n.forgotlink[data-v-7c875044] {margin-left: 10px; color: #999;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7c875044","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/account/Login.vue
// module id = 219
// module chunks = 0